import moment from 'moment';
import 'moment/locale/es';

export const formatDate = (date) =>
  date ? moment.utc(date).format('DD/MM/YYYY HH:mm') : '';

export const formatDateWithoutTime = (date) =>
  date ? moment(date, 'YYYY-MM-DD').format('DD/MM/YYYY') : '';

export const formatDateForCommerce = (date) =>
  date ? moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD') : '';

export const formatEstimatedDeliveryDateMkp = (dispatch) => {
  if (!moment(dispatch.estimated_delivery_date).locale('es').isValid())
    return 'Pendiente';
  try {
    return dispatch.max_estimated_delivery_date
      ? `Entre el ${formatDateToDayMonthText(
          dispatch.estimated_delivery_date,
        )} y ${formatDateToDayMonthText(dispatch.max_estimated_delivery_date)}`
      : `${formatDateToDayMonthText(dispatch.estimated_delivery_date)}`;
  } catch (error) {
    return '';
  }
};

export const formatDateForGiftCards = (date) =>
  date ? moment(date, 'DD-MM-YYYY').format('DD/MM/YYYY') : '';

const formatDateToDayMonthText = (date) => {
  try {
    const newDate = date.split('Z')[0];
    return moment(newDate).format('DD [de] MMMM');
  } catch (error) {
    return '';
  }
};

export const validDateWithoutCharacters = (date) =>
  date ? /^(0[1-9]|[1-2]\d|3[01])(\/)(0[1-9]|1[012])\2(\d{4})$/.test(date) : '';

export const validateDateFormat = (date) => {
  const dateOk = validDateWithoutCharacters(date);
  const changeFormatDate = date.split('/').reverse().join('-');
  return !(!dateOk || changeFormatDate > moment().format('YYYY-MM-DD'));
};
